<template>
  <div class="the-nav">
    <button @click="$emit('scrollEvent')">IP MAKELAARDIJ</button>
    <div class="the-nav__cta">
      <BaseButton>
        <a href="mailto:welkom@ipmakelaardij.nl" target="_blank"
          ><i class="fa-solid fa-envelope"></i
          ><span class="the-nav__cta--tablet"> Mail voor een afspraak</span></a
        >
      </BaseButton>
      <BaseButton>
        <a href="tel:+31649106465"
          ><i class="fa-solid fa-phone"></i
          ><span class="the-nav__cta--desktop"> +31 649 106 465</span></a
        >
      </BaseButton>
    </div>
  </div>
</template>

<script setup>
import BaseButton from "@/components/BaseButton.vue";
</script>

<style>
.the-nav {
  display: flex;
  padding: 0.5rem 1.5rem;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  color: var(--color-darkest);
  background-color: var(--color-secondary);
  z-index: 10;
}

.the-nav__cta {
  display: flex;
  gap: 1.5rem;
}

.the-nav__cta .base-button a {
  font-size: var(--font-size-sm);
}

.the-nav__cta--desktop,
.the-nav__cta--tablet {
  display: none;
}

@media screen and (min-width: 768px) {
  .the-nav {
    padding: 0.875rem 1.5rem;
    background-color: transparent;
  }

  .the-nav__cta--tablet {
    display: inline;
  }
}

@media screen and (min-width: 950px) {
  .the-nav__cta--desktop {
    display: inline;
  }
}
</style>
